import { render } from "./CxDetailsPanel.vue?vue&type=template&id=da9f6fda"
import script from "./CxDetailsPanel.vue?vue&type=script&lang=js"
export * from "./CxDetailsPanel.vue?vue&type=script&lang=js"

import "./CxDetailsPanel.vue?vue&type=style&index=0&id=da9f6fda&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__